export default (
  checksTotal: number | undefined,
  repetitions: number | undefined,
) => (checksTotal && repetitions && checksTotal % repetitions) || 0;
